// MUI
import { styled } from '@mui/material/styles';
import HelpTooltip from 'components/v2/PageElements/HelpTooltip';

const StyledHeading = styled('h3')(({ theme }) => ({
  fontSize: 16,
  fontWeight: '700',
  color: theme.palette.text.secondary,
}));

const Header = ({ text, tooltip, children }) => {
  return (
    <StyledHeading>
      {children}
      {tooltip && <HelpTooltip title={tooltip} />}
    </StyledHeading>
  );
};

export default Header;
